module.exports = __webpack_public_path__ + "img/EmergencyShareOutlined.9f14c268.svg";